import React from 'react';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import InfoBar from '../../components/InfoBar/InfoBar';
import './Business.css';

export default function Business() {
  const services = [
    {
      id: 1,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
      ),
      title: 'Office Subscriptions',
      description: 'Regular flower deliveries to keep your office space fresh and vibrant. Choose weekly, bi-weekly, or monthly subscriptions tailored to your needs.'
    },
    {
      id: 2,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'Corporate Events',
      description: 'Stunning floral arrangements for conferences, product launches, and company celebrations. We handle events of all sizes with professional expertise.'
    },
    {
      id: 3,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      ),
      title: 'Employee Gifting',
      description: 'Show appreciation to your team with personalized flower gifts for birthdays, work anniversaries, and special achievements.'
    },
    {
      id: 4,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      ),
      title: 'Client Relations',
      description: 'Strengthen business relationships with elegant flower arrangements for client offices, thanking them for their partnership and loyalty.'
    },
    {
      id: 5,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <line x1="3" y1="9" x2="21" y2="9"/>
          <line x1="9" y1="21" x2="9" y2="9"/>
        </svg>
      ),
      title: 'Seasonal Decorations',
      description: 'Transform your workspace with seasonal floral designs for holidays, special occasions, and corporate themes throughout the year.'
    },
    {
      id: 6,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      ),
      title: 'Dedicated Account Manager',
      description: 'Enjoy personalized service with a dedicated account manager who understands your business needs and preferences.'
    }
  ];

  const benefits = [
    {
      id: 1,
      title: 'Volume Discounts',
      description: 'Enjoy special pricing for bulk orders and subscription services',
      icon: '💰'
    },
    {
      id: 2,
      title: 'Flexible Billing',
      description: 'Monthly invoicing and payment terms designed for businesses',
      icon: '📋'
    },
    {
      id: 3,
      title: 'Priority Service',
      description: 'Fast-track ordering and delivery for urgent corporate needs',
      icon: '⚡'
    },
    {
      id: 4,
      title: 'Custom Branding',
      description: 'Add your company branding to cards and packaging',
      icon: '🎨'
    }
  ];

  const testimonials = [
    {
      id: 1,
      company: 'TechCorp Solutions',
      logo: '🏢',
      quote: 'Tulipink has transformed our office environment. The weekly flower deliveries create a welcoming atmosphere for both employees and clients.',
      author: 'Sarah Mitchell',
      position: 'HR Director'
    },
    {
      id: 2,
      company: 'Creative Design Studio',
      logo: '🎨',
      quote: 'Their attention to detail and creative arrangements perfectly match our brand aesthetic. Highly recommended for corporate flower services.',
      author: 'James Chen',
      position: 'Studio Manager'
    },
    {
      id: 3,
      company: 'Global Finance Group',
      logo: '💼',
      quote: 'Professional, reliable, and always on time. The quality of their arrangements consistently impresses our executive team and clients.',
      author: 'Emily Rodriguez',
      position: 'Office Manager'
    }
  ];

  return (
    <>
      <InfoBar />
      <NavBar />
      <div className="business-page">
        {/* Hero Section */}
        <section className="business-hero">
          <div className="business-hero-content">
            <h1 className="business-hero-title">Corporate Flower Services</h1>
            <p className="business-hero-subtitle">
              Elevate your business environment with premium flower arrangements and subscriptions
            </p>
            <div className="business-hero-buttons">
              <button className="business-btn business-btn-primary">
                Get a Quote
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14"/>
                  <path d="M12 5l7 7-7 7"/>
                </svg>
              </button>
              <button className="business-btn business-btn-secondary">
                View Services
              </button>
            </div>
          </div>
          <div className="business-hero-stats">
            <div className="business-stat-card">
              <span className="business-stat-number">500+</span>
              <span className="business-stat-label">Corporate Clients</span>
            </div>
            <div className="business-stat-card">
              <span className="business-stat-number">10K+</span>
              <span className="business-stat-label">Deliveries per Year</span>
            </div>
            <div className="business-stat-card">
              <span className="business-stat-number">98%</span>
              <span className="business-stat-label">Client Satisfaction</span>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="business-services">
          <div className="business-container">
            <div className="business-section-header">
              <h2 className="business-section-title">Our Business Services</h2>
              <p className="business-section-description">
                Comprehensive floral solutions designed for corporate environments
              </p>
            </div>
            <div className="business-services-grid">
              {services.map((service) => (
                <div key={service.id} className="business-service-card">
                  <div className="business-service-icon">{service.icon}</div>
                  <h3 className="business-service-title">{service.title}</h3>
                  <p className="business-service-description">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="business-benefits">
          <div className="business-container">
            <div className="business-section-header">
              <h2 className="business-section-title">Why Choose Us</h2>
              <p className="business-section-description">
                Business advantages that make partnership easy
              </p>
            </div>
            <div className="business-benefits-grid">
              {benefits.map((benefit) => (
                <div key={benefit.id} className="business-benefit-card">
                  <span className="business-benefit-icon">{benefit.icon}</span>
                  <h3 className="business-benefit-title">{benefit.title}</h3>
                  <p className="business-benefit-description">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="business-process">
          <div className="business-container">
            <div className="business-section-header">
              <h2 className="business-section-title">How It Works</h2>
              <p className="business-section-description">
                Simple process from inquiry to delivery
              </p>
            </div>
            <div className="business-process-steps">
              <div className="business-step">
                <div className="business-step-number">1</div>
                <h3 className="business-step-title">Contact Us</h3>
                <p className="business-step-description">
                  Reach out to discuss your business flower needs and requirements
                </p>
              </div>
              <div className="business-step-arrow">→</div>
              <div className="business-step">
                <div className="business-step-number">2</div>
                <h3 className="business-step-title">Custom Proposal</h3>
                <p className="business-step-description">
                  Receive a tailored proposal with pricing and service details
                </p>
              </div>
              <div className="business-step-arrow">→</div>
              <div className="business-step">
                <div className="business-step-number">3</div>
                <h3 className="business-step-title">Setup & Delivery</h3>
                <p className="business-step-description">
                  We handle everything from arrangement to scheduled delivery
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="business-testimonials">
          <div className="business-container">
            <div className="business-section-header">
              <h2 className="business-section-title">What Our Clients Say</h2>
              <p className="business-section-description">
                Trusted by leading businesses across industries
              </p>
            </div>
            <div className="business-testimonials-grid">
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="business-testimonial-card">
                  <div className="business-testimonial-logo">{testimonial.logo}</div>
                  <p className="business-testimonial-quote">"{testimonial.quote}"</p>
                  <div className="business-testimonial-author">
                    <h4 className="business-testimonial-name">{testimonial.author}</h4>
                    <p className="business-testimonial-position">{testimonial.position}</p>
                    <p className="business-testimonial-company">{testimonial.company}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="business-cta">
          <div className="business-container">
            <div className="business-cta-content">
              <h2 className="business-cta-title">Ready to Enhance Your Workspace?</h2>
              <p className="business-cta-description">
                Let's discuss how our corporate flower services can benefit your business. 
                Contact us today for a free consultation and custom quote.
              </p>
              <div className="business-cta-buttons">
                <button className="business-btn business-btn-light">
                  Schedule Consultation
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14"/>
                    <path d="M12 5l7 7-7 7"/>
                  </svg>
                </button>
                <button className="business-btn business-btn-outline">
                  Download Brochure
                </button>
              </div>
              <div className="business-contact-info">
                <div className="business-contact-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  <span>+1 (555) 123-4567</span>
                </div>
                <div className="business-contact-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <span>business@tulipink.com</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
